import { onEditorClosed } from '../actions/publicActions';
import { orchestrator } from 'satcheljs';
import { AccountsEditorState } from '../store/schema/AccountsEditorState';
import setAccountsEditorState from '../mutators/setAccountsEditorState';
import getAccountsEditorState from '../selectors/getAccountsEditorState';

orchestrator(onEditorClosed, actionMessage => {
    const accountEditorState = getAccountsEditorState();

    if (
        accountEditorState == AccountsEditorState.AddFailed ||
        accountEditorState == AccountsEditorState.RemoveFailed ||
        accountEditorState == AccountsEditorState.ReconnectFailed
    ) {
        setAccountsEditorState(AccountsEditorState.None);
    }
});
